const prefix = 'SETUP_IMPORT';

export const SET_HISTORY_DATA = `${prefix}_SET_HISTORY_DATA`;


// WEBPACK FOOTER //
// ./src/views/Setup/ObjectImport/flow/actionType.js